import Authorization from './ui/Authorization';

export default Authorization;